export enum AnalyticsFlag {
  WorkplaceOverlapping = 'WORKPLACE_OVERLAPPING',
  ActivityOverlapping = 'ACTIVITY_OVERLAPPING',
}

export interface GroupingInfo {
  by?: string;
  flags: AnalyticsFlag[];
}
